import React from 'react'

const SvgInstantBook = () => (
  <svg viewBox="0 0 18 30" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.778 10.556h-8.89l5-10.556H3.334L0 15h7.222L.556 30z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

export default SvgInstantBook
